import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IParticipantNewApplication } from '../Models/IParticipantNewApplication';
import { IParticipantApplication } from '../Models/IParticipantApplication';
import { ITypedValidationResult } from '../Models/IValidationResult';

class participantApplicationService extends BaseApiService {
    public constructor() {
        super('ParticipantApplication/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': false,
            // Other headers can be added here if needed
        }
    };

    private static authConfig = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async saveNewApplication(participantApplication: IParticipantNewApplication) {
        console.log('Saving New Application');
        return this.httpClient.post<ITypedValidationResult<IParticipantNewApplication>>(`SaveNewApplication`, participantApplication, participantApplicationService.config)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async updateApplication(participantApplication: IParticipantApplication) {
        console.log('Updating Application');
        this.httpClient.post<ITypedValidationResult<IParticipantApplication>>(`SaveApplication`, participantApplication, participantApplicationService.authConfig)
            .catch(this.handleError.bind(this));
    }

    public async testCaptcha(captchaToken: string) {
        console.log('Captcha Test Fired');
        console.log('Captcha Test captcha token: ' + captchaToken);
        return this.httpClient.post<boolean>(`TestCaptcha?cToken=${captchaToken}`, participantApplicationService.config)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }


    //public async getUnprocessed(): Promise<IParticipantApplication[]> {
    //    return this.httpClient.get<IParticipantApplication[]>(`GetUnprocessedApplications`, { headers: { 'AuthorizationNeeded': true, } })
    //        .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    //}

    public async getByParticipantPortalUserId(participantPortalUserId: string, auth0Id: string): Promise<IParticipantApplication> {
        return this.httpClient.get<IParticipantApplication>(`GetByParticipantPortalUserId?participantPortalUserId=${participantPortalUserId}&auth0Id=${auth0Id}`, { headers: { 'AuthorizationNeeded': true, } })
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
}

    export const ParticipantApplicationService: participantApplicationService = new participantApplicationService();